var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-auto"},[_c('b-pagination-nav',{attrs:{"align":"center","link-gen":_vm.linkGen,"number-of-pages":_vm.paginasTotales,"use-router":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }